import Clickable from '../../Clickable';
import Row from '../../Row';
import Text from '../../Text';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const AnimatedRow = styled(Row)`
  opacity: ${(props) => props.opa};
  transition: opacity 0.5s;
`;

const Item = ({ onClick, item, isSelected, dontShow, isSub }) => {
  const [visible, setVisible] = useState(isSub ? 0 : 1),
    { t } = useTranslation();

  useEffect(() => {
    if (dontShow) return setVisible(0);

    setVisible(1);
  }, [dontShow]);

  if (dontShow) return null;

  return (
    <Clickable onClick={onClick}>
      <AnimatedRow
        noFlex
        pad="9px 24px"
        marg="0 8px 0 0"
        hasRadius="32px"
        opa={visible}
        bg={isSelected ? theme.SECONDARY_20 : theme.GREY_10}
        hasBorder={`1px solid ${isSelected ? theme.SECONDARY : 'transparent'}`}
      >
        <Text>{t(item.translatedValue)}</Text>
      </AnimatedRow>
    </Clickable>
  );
};

export default Item;
